module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_shiromuku-727161a2bda80d4d5afca13d7bd2df4c.jpg";